import { render } from "./App.vue?vue&type=template&id=36ae4fab"
const script = {}

import "./App.vue?vue&type=style&index=0&id=36ae4fab&lang=less"

import exportComponent from "E:\\lvdu-manage-static-h5-oss\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__